import { requestStatusLabel, requestStatusTone } from '../data/constants'
import { getReviewStatus, getReviewStatusLabel, getStockStatus, getStockStatusLabel } from '../utils/stock'

const TX_LABELS = {
  IN: { label: '입고', tone: 'in' },
  OPENING: { label: '초기재고', tone: 'in' },
  OUT: { label: '출고', tone: 'out' },
  ADJUSTMENT: { label: '재고조정', tone: 'warn' },
  MERGE: { label: '병합', tone: 'warn' },
  in: { label: '입고', tone: 'in' },
  out: { label: '출고', tone: 'out' },
}

const STOCK_TONE = {
  ok: 'ok',
  low: 'warn',
  out: 'danger',
  unverified: 'pending',
}

const REVIEW_TONE = {
  done: 'ok',
  qty: 'warn',
  spec: 'warn',
  'qty-spec': 'warn',
}

export default function StatusBadge({ part, status, kind = 'stock' }) {
  if (kind === 'request') {
    return <span className={`badge badge--${requestStatusTone(status)}`}>{requestStatusLabel(status)}</span>
  }

  if (kind === 'tx') {
    const meta = TX_LABELS[status] || TX_LABELS[String(status).toUpperCase()] || {
      label: status,
      tone: 'pending',
    }
    return <span className={`badge badge--${meta.tone}`}>{meta.label}</span>
  }

  if (kind === 'verification') {
    const review = status || getReviewStatus(part)
    return <span className={`badge badge--${REVIEW_TONE[review] || 'warn'}`}>{getReviewStatusLabel(review)}</span>
  }

  const stockStatus = status || getStockStatus(part)
  return (
    <span className={`badge badge--${STOCK_TONE[stockStatus] || 'ok'}`}>{getStockStatusLabel(stockStatus)}</span>
  )
}
